/**
 * Safe element labels that don't contain PII.
 * Based on ZP's whitelist approach.
 */
const ALLOWED_LABELS = new Set(
  [
    'Add',
    'Apply',
    'Back',
    'Cancel',
    'Change',
    'Close',
    'Confirm',
    'Continue',
    'Delete',
    'Done',
    'Edit',
    'Get started',
    'Go back',
    'Next',
    'Save',
    'Save & continue',
    'Save and continue',
    'Submit',
    'Update',
  ].map((s) => s.toLowerCase()),
);

/**
 * Return the given string if it's safe to log (doesn't include PII), otherwise return undefined.
 */
export function sanitizeElementName(text: string | null | undefined): string | undefined {
  if (!text) {
    return undefined;
  }

  const normalized = text.toLowerCase().trim();
  if (ALLOWED_LABELS.has(normalized)) {
    return normalized;
  }

  return undefined;
}
